import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e8d527e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }

import LoadingEllipsis from '@/components/common/LoadingEllipsis.vue';
import useI18n from "@/locales/useI18n"
import { computed } from "vue"

import { AddressStatus } from '@/interfaces/admin/places'
type Props = {
  status: AddressStatus | string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationStatus',
  props: {
    status: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props

const normalizedStatus = computed(() => {
  // Map AddressStatus enum values to display states
  if (props.status === AddressStatus.VERIFIED) return 'verified'
  if (props.status === AddressStatus.UNVERIFIED) return 'unverified'
  if (props.status === AddressStatus.ADD_SUBPREMISE) return 'unverified' // Treat as unverified
  return 'undefined'
})

const statusConfig = computed(() => {
  const config = {
    verifying: {
      icon: "",
      text: t("verifying"),
      theme: "is-light"
    },
    verified: {
      icon: "fa-check",
      text: t("verified"),
      theme: "is-success"
    },
    unverified: {
      icon: "fa-exclamation-triangle",
      text: t("unverified"),
      theme: "is-warning"
    },
    undefined: { icon: "", text: "", theme: "" }
  }
  return config[normalizedStatus.value]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['tag is-rounded is-medium', statusConfig.value.theme])
  }, [
    (props.status === 'verifying')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(statusConfig.value.text), 1),
          _createVNode(LoadingEllipsis)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("i", {
              class: _normalizeClass(['fa', statusConfig.value.icon])
            }, null, 2)
          ]),
          _createElementVNode("span", null, _toDisplayString(statusConfig.value.text), 1)
        ], 64))
  ], 2))
}
}

})